module.exports = __webpack_public_path__ + "static/bushido-2-fd2697bda174d92afe8dde1333ab289d.png";